import { Button, TextCutter } from '@anytag/shared-atoms';
import { PostModal } from '@anytag/shared-molecules';
import { useQueryHelper } from '@anytag/shared-hooks';
import { EngagementPost, EngagementPostDetail, EngagementCampaignPostStatus } from '@anytag/graphql';

interface FooterNodeProps {
  isReviewing: boolean;
  selectedPost: EngagementPost;
  postDetails: EngagementPostDetail;
  hasReportInappropriate?: boolean | null;
  handleRejectPost: (postDetails: EngagementPostDetail) => void;
  handleSelectStatus: (status: EngagementCampaignPostStatus, posts: EngagementPost[]) => void;
}
export const FooterNode = ({
  isReviewing,
  postDetails,
  selectedPost,
  handleRejectPost,
  handleSelectStatus,
  hasReportInappropriate
}: FooterNodeProps) => {
  const { t } = useQueryHelper();

  return (
    <PostModal.Footer>
      {isReviewing ? (
        <div className="flex items-center justify-end gap-2">
          <Button
            variant="solid"
            color="danger"
            className="px-6 capitalize"
            title={t('Button.Reject')}
            onClick={() => handleRejectPost(postDetails)}
          />
          <Button
            variant="solid"
            className="px-6 capitalize"
            title={t('Button.Approve Post')}
            onClick={() => handleSelectStatus(EngagementCampaignPostStatus.READY_TO_POST, [selectedPost])}
          />
        </div>
      ) : null}

      {hasReportInappropriate ? (
        <div className="flex items-center justify-between gap-2">
          <TextCutter
            text={t('You can send feedback to creator via Email and AnyCreator')}
            className="text-sm leading-[140%] text-tertiary"
          />
          <Button
            variant="outline"
            className="ml-auto capitalize"
            title={t('Button.Modification Request')}
            onClick={() => handleRejectPost(postDetails)}
          />
        </div>
      ) : null}
    </PostModal.Footer>
  );
};
